export enum SessionPhase {
  Idle = 'idle',
  Created = 'created',
  Trying = 'trying',
  Ringing = 'ringing',
  Active = 'active',
  Held = 'held',
  Ended = 'ended',
  AfterCallWork = 'afterCallWork',
  Rejected = 'rejected',
  Completed = 'completed',
}
